import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Employees from '@/pages/Employees';
import TimeSheet from '@/pages/TimeSheet';
import Calendar from '@/pages/Calendar';
import LeaveRequests from '@/pages/LeaveRequests';
import UserManagement from '@/pages/UserManagement';
import Kiosk from '@/pages/Kiosk';
import ReviewTimeSheet from '@/pages/ReviewTimeSheet';
import EmployeePortal from '@/pages/EmployeePortal';
import Holidays from '@/pages/Holidays';
import Settings from '@/pages/Settings';
import SignContract from '@/pages/SignContract';
import AttendanceSelfService from '@/pages/AttendanceSelfService';
import Attendance from '@/pages/Attendance';
import { Toaster } from '@/components/ui/sonner';
import { LanguageProvider } from '@/context/LanguageContext';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');

    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Hleð...</div>;
  }

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/kiosk" element={<Kiosk />} />
            <Route path="/review/:token" element={<ReviewTimeSheet />} />
            <Route path="/sign/:token" element={<SignContract />} />
            <Route path="/attendance/:token" element={<AttendanceSelfService />} />
            <Route path="/portal" element={<EmployeePortal />} />
            <Route
              path="/login"
              element={!user ? <Login setUser={setUser} /> : <Navigate to="/dashboard" />}
            />
            <Route
              path="/dashboard"
              element={
                user ? (
                  <Dashboard user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/employees"
              element={
                user && user.role === 'admin' ? (
                  <Employees user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/dashboard" />
                )
              }
            />
            <Route
              path="/users"
              element={
                user && user.role === 'admin' ? (
                  <UserManagement user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/dashboard" />
                )
              }
            />
            <Route
              path="/timesheet"
              element={
                user ? (
                  <TimeSheet user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/calendar"
              element={
                user ? (
                  <Calendar user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/leave"
              element={
                user ? (
                  <LeaveRequests user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/attendance"
              element={
                user && user.role === 'admin' ? (
                  <Attendance user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/dashboard" />
                )
              }
            />
            <Route
              path="/holidays"
              element={
                user && user.role === 'admin' ? (
                  <Holidays user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/dashboard" />
                )
              }
            />
            <Route
              path="/settings"
              element={
                user && user.role === 'admin' ? (
                  <Settings user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/dashboard" />
                )
              }
            />
            <Route path="/" element={<Navigate to="/kiosk" />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </LanguageProvider>
    </div>
  );
}

export default App;
